function createTechnologies({ key, name, icon }) {
  return {
    key,
    name,
    icon,
  };
}

export const technologies = [
  createTechnologies({
    key: "game",
    name: "Game",
    icon: "games.png",
  }),
  createTechnologies({
    key: "web",
    name: "Web",
    icon: "web.png",
  }),
  createTechnologies({
    key: "software",
    name: "Software",
    icon: "software.png",
  }),
  createTechnologies({
    key: "mobile",
    name: "Mobile",
    icon: "mobile.png",
  }),
  createTechnologies({
    key: "unity",
    name: "Unity",
    icon: "unity.png",
  }),
  createTechnologies({
    key: "csharp",
    name: "C#",
    icon: "csharp.png",
  }),
  createTechnologies({
    key: "bubble",
    name: "Bubble.io",
    icon: "bubble-io.png",
  }),
  createTechnologies({
    key: "photon",
    name: "Photon",
    icon: "photon.png",
  }),
  createTechnologies({
    key: "javascript",
    name: "Javascript",
    icon: "javascript.png",
  }),
  createTechnologies({
    key: "react",
    name: "React",
    icon: "react.png",
  }),
  createTechnologies({
    key: "nodejs",
    name: "Node.js",
    icon: "node-js.png",
  }),
  createTechnologies({
    key: "java",
    name: "Java",
    icon: "java.png",
  }),
  createTechnologies({
    key: "spring-boot",
    name: "Spring Boot",
    icon: "spring-boot.svg",
  }),
  createTechnologies({
    key: "postgresql",
    name: "PostgreSQL",
    icon: "postgreesql.png",
  }),
  createTechnologies({
    key: "terraform",
    name: "Terraform",
    icon: "terraform.png",
  }),
  createTechnologies({
    key: "next.js",
    name: "Next.js",
    icon: "next-js.webp",
  }),
  createTechnologies({
    key: "IA",
    name: "IA",
    icon: "ia.png",
  }),
];
